import initBlobShow from '~/blob/show/show_blob_bundle';

initBlobShow();
